define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Class = require('Class');
    var AnimationManager = require('managers/animation.manager');

    module.exports = Class.create({
        _configTemplate: _.extend(AnimationManager.prototype._configTemplate, {
            'menu__navigation': false
        })
    });
});
